import { useEffect, useState } from "react";
import PaginatedTableComponent, { Column } from "../../../components/ui/paginated-table";
import IconButton from '../../../components/ui/icon-btn';
import { mdiDeleteOutline, mdiPencilOutline } from "@mdi/js";
import { ExternalData } from "../../../@types/external-api";
import { Col, Row, Spinner } from "react-bootstrap";
import { Translation } from "../../../resources/translations/translations-model";
import { ModalComponent } from "../../../components/ui/modal";

type Props = {
    translationsToolData: ExternalData<Translation[]>
    onEditClick: (rule: Translation) => void,
    onDeleteClick: (rule: Translation) => void
}
export default function TranslationsToolPaginatedList({ translationsToolData, onEditClick, onDeleteClick }: Props) {
    const [selectedPage, setSelectedPage] = useState<number>(0);
    const [modalShow, setModalShow] = useState(false);
    const [translationToDelete, setTranslationToDelete] = useState<Translation | null>(null);
    const [columns] = useState<Column[]>([
        {
            id: 'locale',
            label: 'Locale',
        },
        {
            id: 'translateFrom',
            label: 'Translate from',
        },
        {
            id: 'translateTo',
            label: 'Translate to',
        },
        {
            id: 'edit',
            maxWidth: 1.5,
            getIcon: (row: Translation) => (
                <IconButton
                    mdiIconPath={mdiPencilOutline}
                    onClick={() => onEditClick(row)}
                    color="var(--detail-gray)"
                    title="Edit rule"
                    size="18px"
                />
            ),
        },
        {
            id: 'delete',
            maxWidth: 1.5,
            getIcon: (row: Translation) => (
                <IconButton
                    mdiIconPath={mdiDeleteOutline}
                    onClick={() => {
                        setTranslationToDelete(row)
                        setModalShow(true)
                    }}
                    color="var(--detail-gray)"
                    title="Delete rule"
                    size="18px"
                />
            ),
        },
    ] as Column[]);

    useEffect(() => {
        setSelectedPage(0);
    }, [translationsToolData]);

    if (translationsToolData.loading) {
        return (
            <Row className="loader">
                <Col className="d-flex justify-content-center align-items-center">
                    <Spinner animation="border" variant="success" />
                </Col>
            </Row>
        );
    }

    return (
        <>
            <PaginatedTableComponent
                columns={columns}
                rows={translationsToolData.data}
                rowIdPropName="id"
                selectedPage={selectedPage}
                setSelectedPage={setSelectedPage}
                totalCount={translationsToolData.data?.length ?? Number.MAX_SAFE_INTEGER}
                sx={{ maxWidth: 'calc(100vw - 104px - 2*24px - 32px - 38px - 19px)' }}
            />
            <ModalComponent
                show={modalShow}
                confirmationModal={true}
                onHide={() => setModalShow(false)}
                onConfirm={() => {
                    if (translationToDelete) {
                        onDeleteClick(translationToDelete);
                        setModalShow(false);
                    }
                }
                }
                title="Delete translation"
                body={`Do you want to delete this translation?`}
            />
        </>
    )
}